import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';

const createInitialState = () => ({
  user: null,
  loading: true,
  isAuthenticated: false,
  clerkLoaded: false,
  // The Clerk user the app user was fetched for, so a new Clerk user object for
  // the same person is not a new sign-in
  clerkUserId: null,
  // Clerk says signed in but the API would not give us the user, even after
  // retrying: pages say so instead of sending the person to sign in again
  authError: null,
});

export const useAuthStore = create(
  subscribeWithSelector(
    devtools((set, get) => ({
      ...createInitialState(),
      setLoading: (loading) => set({ loading }),
      setClerkLoaded: (loaded) => set({ clerkLoaded: loaded }),
      setUser: (user) => set({
        user,
        isAuthenticated: !!user,
      }),
      startAuth: () => set({ loading: true, authError: null }),
      completeAuth: ({ user, clerkUserId = null }) => set({
        user: user || null,
        isAuthenticated: !!user,
        loading: false,
        clerkUserId,
        authError: null,
      }),
      failAuth: (authError) => set((state) => ({
        ...createInitialState(),
        loading: false,
        clerkLoaded: state.clerkLoaded,
        authError: authError || 'unknown',
      })),
      clearAuth: () => {
        set((state) => ({
          ...createInitialState(),
          loading: false,
          clerkLoaded: state.clerkLoaded,
        }));
      },
      reset: () => {
        set(createInitialState());
      },
    }), { name: 'AuthStore' })
  )
);

export const selectAuthState = (state) => ({
  user: state.user,
  loading: state.loading,
  isAuthenticated: state.isAuthenticated,
  clerkLoaded: state.clerkLoaded,
  authError: state.authError,
});


